/**
 * Href pro odkazy renderované react-aria komponentami (UUI sidebar nav, `IconAction`,
 * `Table.Row`, `Button href`).
 *
 * `AriaRouterProvider` v `main.tsx` obsluhuje klik přes TanStack Router, který si basepath
 * SPA (`/app`) doplní sám — jenže renderovaný atribut `href` o něm neví. Bez tohoto překladu
 * odkaz vypadá jako `/transaction-logs`: klik funguje, ale „otevřít v novém panelu“,
 * prostřední tlačítko myši nebo zkopírovaný odkaz skončí na serveru mimo SPA a vrátí 404.
 *
 * @param to    cíl tak, jak ho zapsal volající (SPA cesta, absolutní URL, hash…)
 * @param build překlad SPA cesty na výslednou URL (v aplikaci `router.buildLocation`)
 * @returns href k vyrenderování
 */
export function spaHref(to: string, build: (to: string) => string): string {
  // Absolutní a protokolové odkazy (sidebar → `${origin}/actuator/health`, mailto:, tel:)
  // ani odkazy v rámci stránky nepatří routeru — basepath by je rozbil.
  if (!to || to.startsWith("#") || to.startsWith("//") || /^[a-z][a-z0-9+.-]*:/i.test(to)) {
    return to;
  }
  // Serverové cesty mimo SPA (export souborů, Swagger, actuator). Ty se v kódu píšou
  // převážně jako plain <a>, ale kdyby některá prošla react-aria komponentou, nesmí
  // dostat `/app` — na serveru pod tou cestou nic není.
  if (/^\/(admin|api|api-docs|actuator|swagger-ui|v3|error)(\/|$|\.)/.test(to)) {
    return to;
  }
  return build(to);
}
